import AddIcon from "@mui/icons-material/Add";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import PartForm from "../../components/service/partForm.component";
import OrderedPartForm from "../../components/service/orderedPartForm.component";
import { useHasPermission } from "../../contexts/auth";
import { SendByCourierModal } from "../../components/shipping/sendByCourierModal.component";

export const StockStatusListActions = () => {
  const { t } = useTranslation();
  const [addPartOpened, setAddPartOpened] = useState<boolean>(false);
  const [addOrderedPartOpened, setAddOrderedPartOpened] = useState<boolean>(false);
  const canAddPart = useHasPermission("service.add_part");
  const canAddOrderedPart = useHasPermission("service.add_orderedpart");
  const canAddShipment = useHasPermission("shipping.add_shipment");
  const [sendByCourierOpened, setSendByCourierOpened] = useState<boolean>(false);

  const actions: Action[] = [
    {
      id: "add-part",
      icon: <AddIcon />,
      label: t("Add part"),
      onClick: () => { setAddPartOpened(true) },
      disabled: !canAddPart
    },
    {
      id: "add-ordered-part",
      icon: <AddIcon />,
      label: t("Add ordered part"),
      onClick: () => { setAddOrderedPartOpened(true) },
      disabled: !canAddOrderedPart
    },
    ...(canAddShipment ? [{
      id: "send-by-courier",
      icon: <LocalShippingIcon />,
      label: t("Send by courier"),
      onClick: () => { setSendByCourierOpened(true) },
    }] : []),
  ];

  const handlePartAdded = () => {
    setAddPartOpened(false);
    window.dispatchEvent(new Event('partAdded'));
  };

  const handleOrderedPartAdded = () => {
    setAddOrderedPartOpened(false);
    window.dispatchEvent(new Event('orderedPartAdded'));
    window.dispatchEvent(new Event('partUpdated'));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <SendByCourierModal opened={sendByCourierOpened} setOpened={setSendByCourierOpened} />
      <CustomModal
        opened={addPartOpened}
        setOpened={setAddPartOpened}
        title={t("Add part")}
        content={
          <PartForm
            onSuccess={handlePartAdded}
          />
        }
      />
      <CustomModal
        opened={addOrderedPartOpened}
        setOpened={setAddOrderedPartOpened}
        title={t("Add ordered part")}
        content={
          <OrderedPartForm
            onSuccess={handleOrderedPartAdded}
          />
        }
      />
    </>
  );
};
